import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import useSubmitInsightsFeedback from 'messaging-publishing-lib/Insights/hooks/useSubmitInsightsFeedback';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import Raven from 'raven-js';
import { useCallback, useEffect, useMemo, useState } from 'react';
import SentimentButtonWithTooltip from './SentimentButtonWithTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAccordionTransition = styled(AccordionTransition).withConfig({
  displayName: "Feedback__StyledAccordionTransition",
  componentId: "sc-1qrgo2n-0"
})(["width:100%;background-color:", ";"], ({
  theme
}) => theme.color['do-not-use-olaf']);
export default function InsightFeedback(props) {
  const {
    insight
  } = props;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (insight !== null && insight !== void 0 && insight.feedbackEligible) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [insight]);
  if (!insight || !('id' in insight)) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledAccordionTransition, {
    open: open,
    children: /*#__PURE__*/_jsx(InsightFeedbackComponent, Object.assign({}, props))
  });
}
function InsightFeedbackComponent({
  insight: {
    id: insightId,
    insightType: insightName
  },
  sentiment,
  refetchInsights,
  emailType
}) {
  const [selectedSentiment, setSelectedSentiment] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const {
    insightFeedbackSubmissionLoading,
    submitInsightFeedback
  } = useSubmitInsightsFeedback({
    insightId
  });
  const submitFeedback = useCallback(data => {
    submitInsightFeedback(data).then(() => setIsSubmitted(true)).then(() => refetchInsights()).catch(error => Raven.captureException(error));
  }, [refetchInsights, submitInsightFeedback]);
  const feedbackProps = useMemo(() => ({
    action: 'insights-feedback-interaction',
    insightType: sentiment === 'POSITIVE' ? 'GOOD' : 'BAD',
    insightName,
    insightId,
    emailType
  }), [emailType, insightId, insightName, sentiment]);
  const handleSentimentChange = useCallback(value => {
    const canUpdateSentiment = !isSubmitted && !insightFeedbackSubmissionLoading;
    if (canUpdateSentiment) {
      setSelectedSentiment(value);
    }
  }, [insightFeedbackSubmissionLoading, isSubmitted]);
  useEffect(() => {
    if (selectedSentiment) {
      trackInsightsInteraction(Object.assign({}, feedbackProps, {
        otherAction: 'sentiment-click',
        insightFeedbackSentiment: selectedSentiment
      }));
    }
  }, [feedbackProps, selectedSentiment]);
  const commonSentimentButtonProps = {
    selectedSentiment,
    handleSentimentChange,
    isLoading: insightFeedbackSubmissionLoading,
    isSubmitted,
    submitFeedback,
    feedbackProps
  };
  return /*#__PURE__*/_jsxs(UIFlex, {
    justify: "between",
    align: "center",
    children: [/*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "messaging-insights.insights.feedback.title"
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(SentimentButtonWithTooltip, Object.assign({
        iconName: "thumbsUp",
        sentiment: "HELPFUL"
      }, commonSentimentButtonProps)), /*#__PURE__*/_jsx(SentimentButtonWithTooltip, Object.assign({
        iconName: "thumbsDown",
        sentiment: "NOT_HELPFUL"
      }, commonSentimentButtonProps))]
    })]
  });
}